import React, { useEffect, useState } from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const MESES_ABREV = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

function formatFechaCorta(fecha) {
  const [, m, d] = fecha.split('-').map(Number);
  return `${d} ${MESES_ABREV[m - 1]}`;
}

function etiquetaFalta(p) {
  if (p.faltaBcv && p.faltaGenerica) return 'BCV y USD';
  if (p.faltaBcv) return 'BCV';
  return 'USD';
}

function primerDiaMesAnterior() {
  const hoy = new Date();
  const idx = hoy.getFullYear() * 12 + hoy.getMonth() - 1;
  const year = Math.floor(idx / 12);
  const mes = ((idx % 12) + 12) % 12;
  return `${year}-${String(mes + 1).padStart(2, '0')}-01`;
}

export default function PendientesTasas({ onSeleccionar }) {
  const { empresaActiva } = useAuth();
  const [pendientes, setPendientes] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!empresaActiva) return;
    const cargar = () => {
      setCargando(true);
      api
        .get('/tasas-cambio/pendientes')
        .then(({ data }) => setPendientes(data))
        .finally(() => setCargando(false));
    };
    cargar();
    window.addEventListener('tasas-cambio:actualizado', cargar);
    return () => window.removeEventListener('tasas-cambio:actualizado', cargar);
  }, [empresaActiva]);

  if (cargando) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm p-5">
      <div className="flex items-center gap-2 mb-1">
        {pendientes.length > 0 ? (
          <AlertTriangle size={16} className="text-amber-500 flex-shrink-0" />
        ) : (
          <CheckCircle2 size={16} className="text-teal-600 flex-shrink-0" />
        )}
        <p className="font-medium text-slate-600">
          {pendientes.length > 0
            ? `${pendientes.length} día${pendientes.length === 1 ? '' : 's'} sin tasa completa · desde el ${formatFechaCorta(primerDiaMesAnterior())}`
            : `Todo cargado · desde el ${formatFechaCorta(primerDiaMesAnterior())}`}
        </p>
      </div>

      {pendientes.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3">
          {pendientes.map((p) => (
            <button
              key={p.fecha}
              type="button"
              onClick={() => onSeleccionar && onSeleccionar(p)}
              disabled={!onSeleccionar}
              className={`text-xs font-medium rounded-full px-3 py-1 border border-amber-200 bg-amber-50 text-amber-700
                ${onSeleccionar ? 'hover:bg-amber-100 cursor-pointer' : 'cursor-default'}`}
            >
              {formatFechaCorta(p.fecha)} · {etiquetaFalta(p)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
